<template>
	<div class="webContent flex" @click="closeFontBase">
		<div class="release df cf">
			<div class="area df"><i>版块：</i><div class="flex">{{replace(name)}}</div></div>
			<div class="title">
				<textarea puc placeholder="请提出您的问题" v-model="title" readonly></textarea>
			</div>
			<!-- <edit-textarea id="editTextareaObj" ref="editTextarea" class="content flex" data-empty="输入你的回答" :style="{ fontSize: fontBaseStyle.fontSize, lineHeight: fontBaseStyle.lineHeight }" v-model="content"></edit-textarea> -->
			<div id="editorObjCts" class="flex"></div>
			<div class="count df war hao">{{contentLength}}/3000</div>
			<div class="lastFile"><input type="file" accept="application/pdf" @change="toUploadFile($event.currentTarget)" /></div>
			<div class="lastFileCount" v-if="fileList.length>0" @click="tabFileList">{{fileList.length}}个附件</div>
			<div class="fontBase df hao" v-show="isShowFontBase">
				<span class="flex s1" :class="{ cur: fontBase==1 }" @click.stop.prevent="tabFontBase(1)"></span>
				<span class="flex s2" :class="{ cur: fontBase==2 }" @click.stop.prevent="tabFontBase(2)"></span>
				<span class="flex s3" :class="{ cur: fontBase==3 }" @click.stop.prevent="tabFontBase(3)"></span>
				<span class="flex s4" :class="{ cur: fontBase==4 }" @click.stop.prevent="tabFontBase(4)"></span>
				<span class="flex s5" :class="{ cur: fontBase==5 }" @click.stop.prevent="tabFontBase(5)"></span>
				<i>小</i>
				<i>大</i>
			</div>
			<div class="linkBase" v-show="isShowLinkBase">
				<span class="df hao">文本内容：<input puc type="text" class="flex" placeholder="请输入" v-model="linkBaseVal1" /></span>
				<span class="df hao">链接地址：<input puc type="text" class="flex" placeholder="请输入" v-model="linkBaseVal2" /></span>
				<span class="df">
					<em class="flex" @click="resLinkBase">确认</em>
					<em class="flex" @click="closeLinkBase">取消</em>
				</span>
			</div>
			<div class="fileList" v-show="isShowFileList">
				<div class="fileLi df" v-for="(v,i) in fileList" :key="i">
					<div class="fileName ov-d">{{v.name}}</div>
					<em @click="removeFile(i)"></em>
				</div>
			</div>
			<div class="tool df war hao">
				<!-- <div class="fileCount" v-if="fileList.length>0" @click="tabFileList">{{fileList.length}}个附件</div> -->
				<!-- <div class="flex"></div> -->
				<!-- <div class="btn font" @click.stop.prevent="toFontBase"></div> -->
				<!-- <div class="btn link" @click="toLinkBase"></div> -->
				<!-- <div class="btn photo"><input type="file" accept="image/png,image/jpeg,image/jpg" @change="toUploadPhoto($event.currentTarget)" /></div> -->
				<!-- <div class="btn video"><input type="file" accept="video/mpeg,video/avi,video/mov,video/3gp,video/mp4,video/wmv,video/mkv,video/m3u8" @change="toUploadVideo($event.currentTarget)" /></div> -->
				<!-- <div class="btn file"><input type="file" accept="application/pdf" @change="toUploadFile($event.currentTarget)" /></div> -->
				<!-- <div class="btn backoff"></div> -->
				<!-- <div class="btn forward"></div> -->
			</div>
		</div>
		<div class="view" v-show="view.has">
			<div class="viewTitle" data-empty="暂无标题">{{view.title}}</div>
			<div class="viewContent" data-empty="暂无内容" v-html="view.content">{{view.content}}</div>
		</div>

		<!-- 敏感词检测 -->
		<div class="confirm df wao hao" v-if="checkVisible">
			<div class="confirm-box">
				<div class="confirm-txt df wao">内容包含敏感词：<span style="color: #D5001C">{{sensitiveWord}}</span></div>
				<div class="confirm-end df wao hao">
					<div class="confirm-btn" @click="checkVisible = false">确定</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'
	// import edit_textarea from './edit-textarea.vue'

	const root = process.env.H5_API_ROOT;
	import wangEditor from "wangeditor";

	let fontBaseData = {
		1: { fontSize: '0.11rem', lineHeight: '0.21rem' },
		2: { fontSize: '0.13rem', lineHeight: '0.23rem' },
		3: { fontSize: '0.15rem', lineHeight: '0.25rem' },
		4: { fontSize: '0.17rem', lineHeight: '0.27rem' },
		5: { fontSize: '0.19rem', lineHeight: '0.29rem' },
	};

	export default {
		name: 'admin_release_page',
		data () {
			return {
				mid: '',
				name: '',
				title: '',
				content: '',
				isShowFontBase: false,
				fontBase: 3,
				fontBaseStyle: {
					fontSize: fontBaseData[3].fontSize,
					lineHeight: fontBaseData[3].lineHeight,
				},
				isShowLinkBase: false,
				linkBaseVal1: '',
				linkBaseVal2: '',
				isShowFileList: false,
				fileList: [],
				view: {
					has: false,
					title: '',
					content: '',
				},
				contentLength: 0,
				editor: null,
				editorData: '',
				old_editorData: '',

				checkVisible: false,
				sensitiveWord: '',
			}
		},
		mounted(){
			this.mid = this.$route.query.id;
			this.name = this.$route.query.cat;
			this.title = this.$route.query.title;

			const editor = new wangEditor(`#editorObjCts`);
			editor.config.showFullScreen = false //关闭全屏
			editor.config.showLinkImg = false //隐藏插入网络图片
			editor.config.showLinkVideo = false//隐藏插入网络视频
			editor.config.uploadImgMaxSize = 10 * 1024 * 1024 // 图片大小2M
			editor.config.uploadVideoMaxSize = 100 * 1024 * 1024  // 视频大小100M


			editor.config.menus = [
				// 'head',
				// 'bold',
				// 'fontSize',
				// 'fontName',
				// 'italic',
				// 'underline',
				// 'strikeThrough',
				// 'indent',
				// 'lineHeight',
				// 'foreColor',
				// 'backColor',
				// 'link',
				// 'list',
				// 'todo',
				// 'justify',
				// 'quote',
				// 'emoticon',
				'image',
				'video',
				// 'table',
				// 'code',
				// 'splitLine',
				// 'undo',
				// 'redo',
			]
			editor.config.uploadImgServer = root + "upload/singleFile";
			editor.config.uploadFileName = "file";

			editor.config.uploadVideoServer = root + "upload/singleFile";
			editor.config.uploadVideoName = 'file'

			editor.config.uploadImgHooks = {
				// 图片上传并返回了结果，图片插入已成功
				success: function(xhr) {
					console.log("success", xhr);
				},
				// 图片上传并返回了结果，但图片插入时出错了
				fail: function(xhr, editor, resData) {
					console.log("fail", resData);
				},
				// 上传图片出错，一般为 http 请求的错误
				error: function(xhr, editor, resData) {
					console.log("error", xhr, resData);
				},
				// 上传图片超时
				timeout: function(xhr) {
					console.log("timeout");
				},
				// 图片上传并返回了结果，想要自己把图片插入到编辑器中
				// 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
				customInsert: function(insertImgFn, result) {
					// result 即服务端返回的接口
					console.log("customInsert", result);

					// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
					insertImgFn(result.data)
				}
			};

			editor.config.uploadVideoHooks = {
				// 上传视频之前
				before: function(xhr) {
					console.log(xhr)
					// 可阻止视频上传
					// return {
					//     prevent: true,
					//     msg: '需要提示给用户的错误信息'
					// }
				},
				// 视频上传并返回了结果，视频插入已成功
				success: function(xhr) {
					console.log('success', xhr)
				},
				// 视频上传并返回了结果，但视频插入时出错了
				fail: function(xhr, editor, resData) {
					console.log('fail', resData)
				},
				// 上传视频出错，一般为 http 请求的错误
				error: function(xhr, editor, resData) {
					console.log('error', xhr, resData)
				},
				// 上传视频超时
				timeout: function(xhr) {
					console.log('timeout')
				},
				// 视频上传并返回了结果，想要自己把视频插入到编辑器中
				// 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
				customInsert: function(insertVideoFn, result) {
					// result 即服务端返回的接口
					console.log('customInsert', result)

					// insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
					insertVideoFn(result.data)
				}
			}

			// 配置 onchange 回调函数，将数据同步到 vue 中
			editor.config.onchange = newHtml => {
				this.editorData = newHtml;

				var count = newHtml.length;
				if(count>3000){
					this.editor.txt.html(this.old_editorData)
					return;
				}
				this.old_editorData = newHtml;
				this.contentLength = count;
			};
			editor.config.placeholder = '输入你的回答'
			// 创建编辑器
			editor.create();
			this.editor = editor;
		},
		methods: {
			beforeDestroy() {
				// 调用销毁 API 对当前编辑器实例进行销毁
				this.editor.destroy();
				this.editor = null;
			},
			// updateContentLength(count){
			// 	this.contentLength = count;
			// },
			changeModelReleasePrivate(state){
				if(state){
					let content = document.getElementById('editTextareaObj').innerHTML
					content = '<div>'+content+'</div>'
					this.view = {
						has: true,
						title: this.title,
						content: content,
					}
				}else{
					this.view = {
						has: false,
						title: '',
						content: '',
					}
				}
			},
			submitModelRelease(){
				// let content = document.getElementById('editTextareaObj').innerHTML.replace(/(^\s*)|(\s*$)/g, "")
				let content = this.editorData

				if(content==''){
					alert('请输入问题回答');
					return;
				}

				// content = '<div>'+content+'</div>'

				var files = [];
				if(this.fileList.length>0){
					this.fileList.forEach((v,i)=>{
						files.push(v.url);
					})
				}
				// 检测敏感词
				this.h5Ajax('post', '$/questions/checkSensitiveWord', {
					content: content
				}, true).then( r => {
					if(r && r.keyword){
						this.sensitiveWord = r.keyword
						this.checkVisible = true
					}else{
						// 发布回答
						this.h5Ajax('post','$/answers/add',{
							attachments: files.toString(),
							questionId: this.mid,
							content: content,
						}).then(r=>{
							// this.$router.go(-1);
							h5PublicApi.jumpRecard(true);
						}).catch(err => {
							console.error('err:' + err)
						})
					}
				})
			},
			toFontBase(){
				this.isShowFontBase = !this.isShowFontBase;
			},
			tabFontBase(type){
				this.fontBase = type;
				this.fontBaseStyle = {
					fontSize: fontBaseData[type].fontSize,
					lineHeight: fontBaseData[type].lineHeight,
				};
			},
			closeFontBase(){
				this.isShowFontBase = false;
			},
			toLinkBase(){
				this.linkBaseVal1 = '';
				this.linkBaseVal2 = '';
				this.isShowLinkBase = !this.isShowLinkBase;
			},
			resLinkBase(){
				if(this.linkBaseVal1==''){
					alert('请输入文本内容');
					return;
				}else if(this.linkBaseVal2==''){
					alert('请输入链接地址');
					return;
				}

				this.isShowLinkBase = false;
				var html = ' <a style="color: #2440B3; text-decoration: underline;" href="'+this.linkBaseVal2.replace(/\'/g,'\\\'')+'" target="_blank">'+this.linkBaseVal1+'</a> ';
				this.$refs.editTextarea.insertData(html);
			},
			closeLinkBase(){
				this.isShowLinkBase = false;
			},
			toUploadPhoto(obj){
				var that = this;
				var img = obj.value;
				var file = obj.files;
				if(file.length==0){
					return;
				}

				if(!/.(jpg|jpeg|png)$/.test(img.toLowerCase())){
					alert('只允许上传jpg/jpeg/png格式的图片');
					return;
				}

				var fileSize = file[0].size; // kb

				if(fileSize>15*1024*1000){
					alert('图片大小不能超过15M');
					return;
				}

				// var reader = new FileReader();
				// // reader.readAsDataURL(file[0]);
				// // reader.onload = function(hFile){
				// // 	var imgData = new Image();
				// // 	imgData.src = hFile.target.result;
				// // 	imgData.onload = function(){
				// // 		console.log(this.width);
				// // 		console.log(this.height);

				// // 		var html = '<div><img style="max-width: 100%;" src="'+require('@/app/assets/load.gif')+'" /></div>';
				// // 		that.$refs.editTextarea.insertData(html);
				// // 		console.log(file,img);
				// // 	}
				// // }
				// reader.readAsArrayBuffer(file[0]);
				// reader.onload = function(){
				// 	var bf = this.result;
				// 	var blob = new Blob([bf],{type:"text/plain"});

				// 	var html = '<div><img style="max-width: 100%;" src="'+URL.createObjectURL(blob)+'" /></div>';
				// 	that.$refs.editTextarea.insertData(html);
				// }

				this.h5AjaxUpload(file[0]).then(r=>{
					obj.value = '';
					if(r){
						var html = '<div><img style="max-width: 100%;" src="'+r+'" /></div>';
						that.$refs.editTextarea.insertData(html);
					}else{
						alert('上传失败，请重试！');
					}
				}).catch(err => {
					console.error('err:' + err)
					obj.value = '';
					alert('上传失败，请重试！');
				})
			},
			toUploadVideo(obj){
				var that = this;
				var video = obj.value;
				var file = obj.files;
				if(file.length==0){
					return;
				}

				if(!/.(mpeg|avi|mov|3gp|mp4|wmv|mkv|m3u8)$/.test(video.toLowerCase())){
					alert('只允许上传mpeg/avi/mov/3gp/mp4/wmv/mkv/m3u8格式的视频');
					return;
				}

				var fileSize = file[0].size; // kb

				if(fileSize>100*1024*1000){
					alert('视频大小不能超过100M');
					return;
				}

				// var videoData = URL.createObjectURL(new Blob([file[0]], {type: "application/zip"}));
				// var audioElement = new Audio(videoData);
				// audioElement.addEventListener("loadedmetadata", function (_event) {
				// 	if(Math.floor(audioElement.duration)>60){
				// 		alert('视频长度不能超过60秒');
				// 		return;
				// 	}

				// 	var html = '<div><video controls="controls" style="width: 100%;" src="'+videoData+'"></video></div>';
				// 	that.$refs.editTextarea.insertData(html);

				// 	console.log(file,video);
				// });

				this.h5AjaxUpload(file[0]).then(r=>{
					obj.value = '';
					if(r){
						var html = '<div><video controls="controls" style="width: 100%;" src="'+r+'"></video></div>';
						that.$refs.editTextarea.insertData(html);
					}else{
						alert('上传失败，请重试！');
					}
				}).catch(err => {
					console.error('err:' + err)
					obj.value = '';
					alert('上传失败，请重试！');
				})
			},
			toUploadFile(obj){
				var that = this;
				var video = obj.value;
				var file = obj.files;
				if(file.length==0){
					return;
				}
				if(!/.(pdf)$/.test(video.toLowerCase())){
					alert('只允许上传pdf格式的文件');
					return;
				}

				var fileSize = file[0].size; // kb

				if(fileSize>50*1024*1000){
					alert('文件大小不能超过50M');
					return;
				}

				this.h5AjaxUpload(file[0]).then(r=>{
					obj.value = '';
					if(r){
						var name = r.split('/');
						that.fileList.push({
							name: name[name.length-1],
							url: r,
						})
					}else{
						alert('上传失败，请重试！');
					}
				}).catch(err => {
					console.error('err:' + err)
					obj.value = '';
					alert('上传失败，请重试！');
				})
			},
			tabFileList(){
				this.isShowFileList = !this.isShowFileList;
			},
			removeFile(index){
				this.fileList.splice(index,1);

				if(this.fileList.length==0){
					this.isShowFileList = false;
				}
			},
			openConfirm(){
				this.confirm = {
					has: true,
				};
			},
			closeConfirm(){
				this.confirm.has = false;
				
				h5PublicApi.tabNavTed('set','meIndexModel','');
				h5PublicApi.tabNavTed('set','meIndexNav','');
				h5PublicApi.tabNavTed('set','meIndexNav2','');
				
				this.$router.replace({ path: '/me' });
			},
				replace(input){
					return input.replace('<br/>','');
				}
		},
	}
</script>

<style scoped>
	@import './release';
</style>

<style>
	#editorObjCts { width: 100%; overflow: hidden; }
	#editorObjCts .w-e-toolbar { position: absolute; left: 0; right: 0; bottom: 0; border: 0 !important; background: #f5f5f5 !important; height: 0.3rem; padding: 0 0.46rem 0 0.1rem; -webkit-box-pack: end; -ms-flex-pack: end; justify-content: flex-end; }
	#editorObjCts .w-e-text-container { height: 100% !important; border: 0 !important; -webkit-overflow-scrolling: touch;}
	#editorObjCts .w-e-menu { width: 0.3rem; height: 0.3rem; margin-right: 0.06rem; }
	#editorObjCts .w-e-up-btn { width: 100%; height: 100%; }
	#editorObjCts .w-e-icon-image { background: url(../../../assets/release-photo2x.png) center center / 0.24rem auto no-repeat; width: 100%; height: 100%; display: block; }
	#editorObjCts .w-e-icon-image::before { content: ''; }
	#editorObjCts .w-e-icon-play { background: url(../../../assets/release-video2x.png) center center / 0.24rem auto no-repeat; width: 100%; height: 100%; display: block; }
	#editorObjCts .w-e-icon-play::before { content: ''; }
	#editorObjCts .w-e-menu-tooltip-up { display: none !important; }
	#editorObjCts .w-e-panel-container { width: 100% !important; position: fixed; left: 0; bottom: 0.3rem; top: 0.605rem; background: #fff; margin-left: 0 !important; box-shadow: 0 0 0.02rem 0.01rem #ccc; border: 0; margin-top: 0 !important; z-index: 10005 !important; }
	.lastFile { width: 0.3rem; height: 0.3rem; margin-right: 0.06rem; position: absolute; right: 0.1rem; bottom: 0; z-index: 10001; background: url(../../../assets/release-file.png) center center / 0.2rem auto no-repeat; }
	.lastFile input { position: absolute; left: 0; right: 0; top: 0; bottom: 0; width: 100%; height: 100%; opacity: 0; }
	.lastFileCount { font-size: 0.12rem; line-height: 0.3rem; color: #333; padding: 0 0.12rem; text-decoration: underline; position: fixed; left: 0.1rem; bottom: 0; z-index: 10005; }
	body .confirm { z-index: 12000 !important; }
</style>



// WEBPACK FOOTER //
// src/app/pages/admin/release/release.vue